import yichen from 'yichen_encrypt'
export default class PwdUtils {
  static encode(pwd) {
    // $log(yichen)
    return yichen.PwdUtils.encode(pwd)
  }

  static randomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    // Generate 128-bit (16 bytes) random values
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);

    // Convert each byte to a character from the characters set
    for (let i = 0; i < length; i++) {
      result += characters.charAt(randomValues[i] % charactersLength);
    }

    return result;
  }
}
